import { Injectable } from '@angular/core';

import { PagedQueryStore, ResourceStore } from '@reforgium/statum';

import {
  DocumentDto,
  DocumentEditData,
  DocumentFileData,
  DocumentFileDto,
  DocumentsFilter,
  DocumentVersionDto,
  DocumentVersionEditData,
  PublicDocumentDto,
} from 'entities/document.model';

@Injectable()
export class DocumentService {
  document = new ResourceStore<DocumentDto>({
    GET: 'api/public/documents/:documentId',
    POST: 'api/documents',
    PUT: 'api/documents/:documentId',
  });
  publicDocumentVersion = new ResourceStore<DocumentVersionDto>({ GET: 'api/public/documents/version/:id' });
  files = new ResourceStore<DocumentFileDto[]>({
    GET: 'api/public/documents/versions/:versionId/files',
  });

  documents = new PagedQueryStore<PublicDocumentDto, DocumentsFilter>('api/public/documents', {
    presetQuery: {
      page: 0,
      pageSize: 10000,
    },
    presetSort: [{ sort: 'updatedAt', order: 'desc' }],
  });

  versions = new ResourceStore<DocumentVersionDto[]>({
    GET: 'api/public/documents/:id/versions',
  });

  documentVersion = new ResourceStore<DocumentVersionDto>({
    POST: 'api/document-versions/:documentId',
    PUT: 'api/document-versions/:versionId',
    DELETE: 'api/document-versions/:versionId',
  });

  fileUpload = new ResourceStore<DocumentFileDto>({
    POST: 'api/documents/versions/:versionId/files/upload',
  });

  fileDownload = new ResourceStore<Blob>({
    POST: 'api/public/documents/versions/:versionId/files/:fileId/download',
  });

  editDocument = (documentId: number, data: DocumentEditData) => {
    return this.document.put({ params: { documentId }, payload: data });
  };

  editDocumentVersion = (versionId: number, data: DocumentVersionEditData) => {
    return this.documentVersion.put({ params: { versionId }, payload: data });
  };

  upload(versionId: number, params: DocumentFileData, file: File) {
    const form = new FormData();

    form.append('file', file);

    return this.fileUpload.post({ params: { versionId }, query: params, payload: form });
  }

  download(versionId: number, fileId: number) {
    return this.fileDownload.post({ params: { versionId, fileId }, payload: {} }, { responseType: 'blob' });
  }
}
